export default __webpack_public_path__ + "assets/sounds/56bb99f4aa64b6dd106269e627cbe935.mp3";